import script from "./AnalysisStatusBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnalysisStatusBadge.vue?vue&type=script&setup=true&lang=ts"

import "./AnalysisStatusBadge.vue?vue&type=style&index=0&id=465d6f2d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-465d6f2d"]])

export default __exports__